import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { VisitsCallsTargetsKpiCfg, VisitsCallsTargetsKpiCfgService } from "./visitsCallsTargetsKpiCfg.service";

export class VisitDetailData {
    public employeeId: string;
    public unitId: string;
    public clientId: string;
    public centerId: string;
    public clientCif: string;
    public clientName: string;
    public segment: string;
    public date: Date;
    public type: string;
    public updateTimestamp: Date;
}

export class CallDetailData {
    public employeeId: string;
    public unitId: string;
    public clientid: string;
    public centerId: string;
    public clientCif: string;
    public clientName: string;
    public segment: string;
    public date: Date;
    public updateTimestamp: Date;
}

export class HangoutDetailData {
    public employeeId: string;
    public unitId: string;
    public clientId: string;
    public centerId: string;
    public clientCif: string;
    public clientName: string;
    public segment: string;
    public date: Date;
    public type: string;
    public updateTimestamp: Date;
}

export class OfferingDetailData {
    public employeeId: string;
    public unitId: string;
    public clientId: string;
    public centerId: string;
    public clientName: string;
    public segment: string;
    public date: Date;
    public jobTitle: string;
    public jobType: string;
    public candidateCount: number;
    public offeringCount: number;
    public updateTimestamp: Date;
}

export class VisitsCallsTargetsData {
    public officeId: string;
    public nif: string;
    public name: string;

    public visitCount: number;
    public visits: VisitDetailData[];
    public visitsUpdateTimestamp: Date;

    public visitsTarget: number;
    public visitsTargetUpdateTimestamp: Date;

    public callCount: number;
    public calls: CallDetailData[];
    public callsUpdateTimestamp: Date;

    public hangoutCount: number;
    public hangouts: HangoutDetailData[];
    public hangoutsUpdateTimestamp: Date;

    public offeringCount: number;
    public offerings: OfferingDetailData[];
    public offeringsUpdateTimestamp: Date;
}

export class VisitsCallsTargetsServiceData {
    public consultantEntry: VisitsCallsTargetsData
    public entries: VisitsCallsTargetsData[];
    public officeVisitCount: number;
    public officeVisitsUpdateTimestamp: Date;
    public officeVisitsTarget: number;
    public officeVisitsTargetUpdateTimestamp: Date;
    public officeCalls: number;
    public officeCallsUpdateTimestamp: Date;
    public officeHangouts: number;
    public officeHangoutsUpdateTimestamp: Date;
    public officeOfferings: number;
    public officeOfferingsUpdateTimestamp: Date;
}

@Injectable()
export class VisitsCallsTargetsService extends KpiService<VisitsCallsTargetsServiceData> {
    public getClassName() { return "VisitsCallsTargetsService"; }

    constructor(private serviceCfg: VisitsCallsTargetsKpiCfgService, private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected async update(): Promise<VisitsCallsTargetsServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: VisitsCallsTargetsServiceData = null;
            try {
                let cfg: VisitsCallsTargetsKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.visitsCallsTargets.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.get<VisitsCallsTargetsServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }
            if (result == null) {
                throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            }
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}